import { useQuery } from "@tanstack/react-query";

import { featuresKeys } from "@/application/query-keys/features.keys";
import { supabase } from "@/infrastructure/supabase/client";

/**
 * Returns a map of architecture component_id → number of features bound to it.
 * Used by the architecture map to render a small count badge per component
 * node. Read-only; feature management happens on the kanban boards.
 */
export function useFeatureCountsByComponent() {
  return useQuery({
    queryKey: [...featuresKeys.all, "counts-by-component"] as const,
    queryFn: async (): Promise<Record<string, number>> => {
      const { data, error } = await supabase
        .from("features")
        .select("component_id")
        .not("component_id", "is", null);
      if (error) throw error;
      const counts: Record<string, number> = {};
      for (const row of data ?? []) {
        const id = (row as { component_id: string | null }).component_id;
        if (!id) continue;
        counts[id] = (counts[id] ?? 0) + 1;
      }
      return counts;
    },
    staleTime: 30_000,
  });
}
